import { render } from "./CommentsCounter.vue?vue&type=template&id=617e7cde&ts=true"
import script from "./CommentsCounter.vue?vue&type=script&lang=ts"
export * from "./CommentsCounter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__